/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import moment from "moment";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import PhaseModal from "../StudyPhaseManagement/PhaseModal.vue";


export default {
    name: "StudyPhase",
    components: {
        VPagination,
        PhaseModal,
    },
    data() {
        return {
            searchField: {
                country: "",
                status: "",
            },
            baseurl: process.env.VUE_APP_Service_URL,
            currentPage: 1,
            totalPage: 1,
            pageindex: 1,
            pagesize: 10,
            SortProperty: "createdAt",
            SortOrder: 1,
            SortOrderInt: 0,
            isAscending: true,
            phaseList: [],
            totalCount: 0,
            showTableLoading: false,

            idToken: "",
            showFilter: false,
            selectedcolumnobj: {},
            roleprivileges: "",

            dropdownOpen: false,
            showCreatePhaseModal: false,
            editingPhaseId: null,
        }
    },

      computed:{
                  rollsprivilages() {
                  return store.getters.getRolesprivilegeData || [];
                  }
               },


    async mounted() {
        window.addEventListener("studyIdChanged", (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.idToken = store.getters.getIdToken;
            this.listPhases();
        });
        this.listPhases();
    },

    methods: {
        async setroleprivileges() {
            this.roleprivileges = await store.getters.getRolesprivilegeData;
        },

        async listPhases() {
            try {
                this.showTableLoading = true;

                const studyId = store.getters.getStudyIs;
                this.idToken = store.getters.getIdToken;

                const response = await axios.get(
                    `${this.baseurl}/management/studyphase/getstudyphases`,
                    {
                        params: {
                            studyId: studyId,
                            pagesize: this.pagesize,
                            pageindex: this.currentPage,
                            SortProperty: this.SortProperty,
                            SortOrder: this.isAscending ? 0 : 1
                        },
                        headers: {
                            Authorization: "Bearer " + this.idToken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.phaseList = response.data.data || [];

                this.totalCount = response.data.totalCount;

                this.totalPage = Math.ceil(this.totalCount / this.pagesize);

            } catch (error) {
                console.error("Error fetching phases:", error);
                this.phaseList = [];
            } finally {
                this.showTableLoading = false;
            }
        },

        EditPhase(id) {
            console.log("Edit Phase:", id);
            this.editingPhaseId = id;
            this.showCreatePhaseModal = true;
        },

        async DeletePhase(id) {
            if (confirm("Are you sure you want to delete this Phase?")) {
                try {
                    await axios.delete(
                        `${this.baseurl}/management/studyphase/deletestudyphase?id=${id}`,
                        {
                            headers: {
                                Authorization: "Bearer " + this.idToken,
                            },
                        }
                    );

                    alert("Phase deleted successfully");
                      if (this.phaseList.length === 1 && this.currentPage > 1) {
                this.currentPage--; 
            }
                    this.listPhases();

                } catch (error) {
                    console.error(error);
                    alert("Delete failed");
                }
            }
        },

        loadPage(page) {
            this.currentPage = page;
            this.listPhases();
        },

        SortSelected(prop) {
            if (this.SortProperty === prop) {
                this.isAscending = !this.isAscending;
            } else {
                this.SortProperty = prop;
                this.isAscending = true;
            }

            this.listPhases();
        },

        formatDate(date) {
            if (!date) return "";
            const d = new Date(date);
            return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
        },

        CreatePhase() {
            console.log("Create Phase clicked");
            this.editingPhaseId = null;
            this.showCreatePhaseModal = true;
        },
        closePhaseModal() {
            this.showCreatePhaseModal = false;
            this.editingPhaseId = null;
        },
        refreshPhaseList() {
            this.listPhases();
        },
    }
};